import { Page } from "pages/ui/layout/page";
import CosmosStar from "shared/assets/svg/cosmos-star.svg?react";
import { useCompletedTasksQuery } from "shared/tg/hooks/use-completed-tasks-query";

import { HistoryItem } from "./history-item";
import { Passport } from "./passport";

const dateTimeFormatter = new Intl.DateTimeFormat("en-US");

export const Profile = () => {
  const tasksQuery = useCompletedTasksQuery();
  const completedTasks = tasksQuery.data ?? [];

  return (
    <Page className="overflow-y-auto">
      <Passport className="mx-6 min-h-96 grow" />
      <h2 className="text-oil mt-6 px-6 text-center text-lg">Your activity</h2>

      {!completedTasks.length && tasksQuery.isSuccess && (
        <div className="text-balticSea/50 relative m-auto text-center text-sm font-medium whitespace-pre-line">
          <CosmosStar className="absolute -top-11 left-1/3 size-5" />
          <CosmosStar className="absolute -top-9 -right-6" />
          <CosmosStar className="absolute -bottom-6 -left-4 size-7" />
          {"No recent activity. Your activity will\nappear here!"}
        </div>
      )}

      <div className="mt-3 h-fit px-6">
        {completedTasks.map((task) => {
          return (
            <HistoryItem
              key={task.systemName}
              date={dateTimeFormatter.format(new Date(task.completedAt))}
              reward={task.reward}
              title={task.title}
            />
          );
        })}
      </div>
    </Page>
  );
};
